import React, { useEffect, useContext, useState } from "react";
import { setCookieItem } from "../../helpers/functions/cookie";
import { useNavigate } from "react-router-dom";
import { useToast } from '@chakra-ui/react'
import { signin } from "../../services/auth";
import { AuthContext } from "../../contexts/AuthContext";
import { AdminContext } from "../../contexts/AdminContext";
import AuthLayout from "../../layouts/AuthLayout";
import SigninForm from "../../components/forms/SigninForm";
import { useForm } from '@mantine/form';
import { SigninSuccess } from "../../components/alert/SigninSuccess";

export interface SigninData {
  email: string;
  password: string;
}

export default function Signin() {
  const [isLoading, setIsLoading] = useState(false)
  const { setIsAuthenticated } = useContext(AuthContext)
  const { setAdmin } = useContext(AdminContext)
  const toast = useToast()
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Signin";
  }, []);

  const form = useForm({
    initialValues: {
      email: '',
      password: ''
    },

    validate: {
      email: (value) => (
        !value ? 'Email is required' :
          !/^\S+@\S+$/.test(value) ? 'Invalid email' : null
      ),
      password: (value) => (
        !value ? 'Password is required' : null
      )
    },
  });

  const handleSignin = async (values: SigninData) => {
    setIsLoading(true)
    const now = new Date()

    try {
      const admin = await signin(values)
      admin.expiry = now.getTime() + 86400000 // 1 day

      setCookieItem('eden_admin', admin)
      setAdmin(admin)
      setIsLoading(false)
      form.reset();
      toast({
        title: "Signin success!",
        status: 'success',
        isClosable: true,
        duration: 2000,
        render: () => <SigninSuccess />
      })

      const params = new URLSearchParams(window.location.search);

      if (params.has("redirect")) {
        const redirectUrl = params.get("redirect");
        if (redirectUrl !== null) {
          setTimeout(() => {
            setIsAuthenticated(true)
            navigate(redirectUrl);
          }, 2000);
        }
      } else {
        setTimeout(() => {
          setIsAuthenticated(true)
          navigate("/dashboard");
        }, 2000);
      }
    } catch (error: any) {
      setIsLoading(false)

      form.setErrors({
        email: error.response.data.message
      })
    }
  }

  const bypassAuth = async () => {
    setIsLoading(true)
    const now = new Date()

    try {
      const admin = await signin({
        email: process.env.REACT_APP_ADMIN_USER,
        password: process.env.REACT_APP_ADMIN_USER
      })

      admin.expiry = now.getTime() + 86400000 // 1 day

      setCookieItem('eden_admin', admin)
      setAdmin(admin)
      setIsLoading(false)
      form.reset();
      toast({
        title: "Signin success!",
        status: 'success',
        isClosable: true,
        duration: 2000,
        render: () => <SigninSuccess />
      })

      const params = new URLSearchParams(window.location.search);

      if (params.has("redirect")) {
        const redirectUrl = params.get("redirect");
        if (redirectUrl !== null) {
          setTimeout(() => {
            setIsAuthenticated(true)
            navigate(redirectUrl);
          }, 2000);
        }
      } else {
        setTimeout(() => {
          setIsAuthenticated(true)
          navigate("/dashboard");
        }, 2000);
      }
    } catch (error: any) {
      setIsLoading(false)

      form.setErrors({
        email: error.response.data.message
      })
    }
  }

  return (
    <AuthLayout>
      <SigninForm 
        form={form} 
        isLoading={isLoading} 
        handleSignin={handleSignin} 
        bypassAuth={bypassAuth}
      />
    </AuthLayout>
  )
}